const api = {
  Login: '/user/login',
  UserInfo: '/user/userinfo',
  UserName: '/user/name',
  ChargingStation: '/app/charging/stations/',
  OutdoorPois: '/app/pois/',
  GetChargeElevatorList: '/app/charging/station/elevators/',
  // 查询充电站相近电梯列表
  GetCollectList: '/application/collects/',
  // 获取收藏列表
  AddCollect: '/application/collect/',
  // 添加收藏
  DelCollect: '/application/collect/' // 删除收藏
};

export default api;